var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.ready && _vm.eventInfo
      ? _c(
          "div",
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c("div", { staticClass: "q-display-1" }, [
                  _vm._v("Event: " + _vm._s(_vm.eventInfo.name))
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-md-4 text-right" },
                [
                  _c("q-btn", {
                    staticClass: "q-mr-lg",
                    attrs: {
                      color: "secondary",
                      label: "Add Group/Team",
                      icon: "add"
                    },
                    on: { click: _vm.addGroup }
                  }),
                  _c("q-btn", {
                    attrs: { color: "primary", label: "Save", icon: "save" },
                    on: { click: _vm.save }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.attendeesWithoutGroup && _vm.attendeesWithoutGroup.length
                  ? _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c(
                          "q-card",
                          { staticClass: "mdi-card q-mb-lg" },
                          [
                            _c(
                              "q-card-main",
                              { staticClass: "q-pa-none" },
                              [
                                _c(
                                  "q-list",
                                  { attrs: { highlight: "", separator: "" } },
                                  [
                                    _c("q-list-header", [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-6 text-primary" },
                                          [_vm._v("No Team Assigned")]
                                        )
                                      ])
                                    ]),
                                    _vm._l(_vm.attendeesWithoutGroup, function(
                                      attendee,
                                      index
                                    ) {
                                      return attendee
                                        ? _c(
                                            "div",
                                            {
                                              key: attendee.id,
                                              staticClass: "items-center",
                                              attrs: { id: attendee.id }
                                            },
                                            [
                                              _c(
                                                "q-item",
                                                { attrs: { separator: "" } },
                                                [
                                                  _c(
                                                    "q-item-side",
                                                    { attrs: { left: "" } },
                                                    [
                                                      attendee.purchaseId
                                                        ? _c(
                                                            "q-item-tile",
                                                            {
                                                              attrs: {
                                                                color: "black"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    attendee.purchaseId
                                                                  ) +
                                                                  "\n                                            "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "q-item-main",
                                                    {
                                                      class: [
                                                        _vm.dragging
                                                          ? "moving"
                                                          : ""
                                                      ]
                                                    },
                                                    [
                                                      attendee.person &&
                                                      attendee.person
                                                        .firstName &&
                                                      attendee.person.lastName
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                attendee.person
                                                                  .firstName
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  attendee
                                                                    .person
                                                                    .lastName
                                                                )
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      attendee.primaryRegistrant
                                                        ? _c(
                                                            "q-icon",
                                                            {
                                                              attrs: {
                                                                name: "star",
                                                                color: "green"
                                                              }
                                                            },
                                                            [
                                                              _c("q-tooltip", [
                                                                _vm._v(
                                                                  "Primary Registrant"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c("br"),
                                                      attendee.person &&
                                                      attendee.person.company &&
                                                      attendee.person.company
                                                        .name
                                                        ? _c("small", [
                                                            _vm._v(
                                                              "\n                                                (" +
                                                                _vm._s(
                                                                  attendee
                                                                    .person
                                                                    .company
                                                                    .name
                                                                ) +
                                                                ")\n                                            "
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "q-item-side",
                                                    { attrs: { right: "" } },
                                                    [
                                                      _vm.attendeesWithoutGroup &&
                                                      _vm.attendeesWithoutGroup[
                                                        index
                                                      ] &&
                                                      _vm.attendeesWithoutGroup[
                                                        index
                                                      ].eventTeamId === null &&
                                                      _vm.teamOptions &&
                                                      _vm.teamOptions.length
                                                        ? _c(
                                                            "q-item-tile",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "swap_horiz",
                                                                color: "black"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "q-popover",
                                                                [
                                                                  _c(
                                                                    "q-list",
                                                                    {
                                                                      attrs: {
                                                                        separator:
                                                                          "",
                                                                        link: ""
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.teamOptions,
                                                                      function(
                                                                        team
                                                                      ) {
                                                                        return _c(
                                                                          "q-item",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "close-overlay",
                                                                                rawName:
                                                                                  "v-close-overlay"
                                                                              }
                                                                            ],
                                                                            key:
                                                                              team.value,
                                                                            nativeOn: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.changeTeams(
                                                                                  attendee,
                                                                                  team.value
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "q-tooltip",
                                                                              [
                                                                                _vm._v(
                                                                                  "Move to:"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  team.label
                                                                                ) +
                                                                                "\n                                                        "
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("q-item-separator", {
                                                staticStyle: {
                                                  display: "block"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(_vm.attendeesByGroup, function(group, groupIndex) {
                  return _c(
                    "div",
                    { key: groupIndex, staticClass: "col-3" },
                    [
                      _c(
                        "q-card",
                        { staticClass: "mdi-card q-mb-lg" },
                        [
                          _c(
                            "q-card-main",
                            { staticClass: "q-pa-none" },
                            [
                              _c(
                                "q-list",
                                { attrs: { highlight: "", separator: "" } },
                                [
                                  _c("q-list-header", [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-6" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.findEventTeamName(
                                                  groupIndex
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                          _vm.eventInfo.eventTeam[
                                            _vm.findEventTeamIndex(groupIndex)
                                          ]
                                            ? _c(
                                                "q-popup-edit",
                                                {
                                                  attrs: {
                                                    buttons: "",
                                                    validate: _vm.nameValidate
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.eventInfo.eventTeam[
                                                        _vm.findEventTeamIndex(
                                                          groupIndex
                                                        )
                                                      ].teamName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.eventInfo.eventTeam[
                                                          _vm.findEventTeamIndex(
                                                            groupIndex
                                                          )
                                                        ],
                                                        "teamName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "eventInfo.eventTeam[findEventTeamIndex(groupIndex)].teamName"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "q-field",
                                                    { attrs: { count: "" } },
                                                    [
                                                      _c("q-input", {
                                                        attrs: {
                                                          min: "1",
                                                          placeholder:
                                                            "Group/Team Name"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.eventInfo
                                                              .eventTeam[
                                                              _vm.findEventTeamIndex(
                                                                groupIndex
                                                              )
                                                            ].teamName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.eventInfo
                                                                .eventTeam[
                                                                _vm.findEventTeamIndex(
                                                                  groupIndex
                                                                )
                                                              ],
                                                              "teamName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "eventInfo.eventTeam[findEventTeamIndex(groupIndex)].teamName"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-6 text-right" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                {
                                                  "text-negative":
                                                    group.length >
                                                    _vm.eventInfo.teamLimit
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(group.length) +
                                                  "/" +
                                                  _vm._s(
                                                    _vm.eventInfo.teamLimit
                                                  )
                                              )
                                            ]
                                          ),
                                          _c("q-btn", {
                                            attrs: {
                                              icon: "delete",
                                              flat: "",
                                              color: "negative",
                                              size: "sm"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteGroup(
                                                  groupIndex
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]),
                                  _vm._l(group, function(attendee) {
                                    return attendee
                                      ? _c(
                                          "div",
                                          {
                                            key: attendee.id,
                                            staticClass: "items-center",
                                            class: [
                                              _vm.sortable ? "sorting" : ""
                                            ],
                                            attrs: {
                                              multiline: "",
                                              id: attendee.id
                                            }
                                          },
                                          [
                                            _c(
                                              "q-item",
                                              { attrs: { separator: "" } },
                                              [
                                                _c(
                                                  "q-item-side",
                                                  { attrs: { left: "" } },
                                                  [
                                                    attendee.purchaseId
                                                      ? _c(
                                                          "q-item-tile",
                                                          {
                                                            attrs: {
                                                              color: "black"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  attendee.purchaseId
                                                                )
                                                              )
                                                            ]),
                                                            _c("q-tooltip", [
                                                              _vm._v(
                                                                "Registration ID"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-item-main",
                                                  {
                                                    class: [
                                                      _vm.dragging
                                                        ? "moving"
                                                        : ""
                                                    ]
                                                  },
                                                  [
                                                    attendee.person &&
                                                    attendee.person.firstName &&
                                                    attendee.person.lastName
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              attendee.person
                                                                .firstName
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                attendee.person
                                                                  .lastName
                                                              )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    attendee.primaryRegistrant
                                                      ? _c(
                                                          "q-icon",
                                                          {
                                                            attrs: {
                                                              name: "star",
                                                              color: "green"
                                                            }
                                                          },
                                                          [
                                                            _c("q-tooltip", [
                                                              _vm._v(
                                                                "Primary Registrant"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c("br"),
                                                    attendee.person &&
                                                    attendee.person.company &&
                                                    attendee.person.company.name
                                                      ? _c("small", [
                                                          _vm._v(
                                                            "\n                                                (" +
                                                              _vm._s(
                                                                attendee.person
                                                                  .company.name
                                                              ) +
                                                              ")\n                                            "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "q-item-side",
                                                  { attrs: { right: "" } },
                                                  [
                                                    _vm.attendees &&
                                                    _vm.attendees[
                                                      _vm.findAttendeeIndex(
                                                        attendee.id
                                                      )
                                                    ] &&
                                                    _vm.attendees[
                                                      _vm.findAttendeeIndex(
                                                        attendee.id
                                                      )
                                                    ].eventTeamId
                                                      ? _c(
                                                          "q-item-tile",
                                                          {
                                                            attrs: {
                                                              icon:
                                                                "swap_horiz",
                                                              color: "black"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "q-popover",
                                                              [
                                                                _c(
                                                                  "q-list",
                                                                  {
                                                                    attrs: {
                                                                      separator:
                                                                        "",
                                                                      link: ""
                                                                    }
                                                                  },
                                                                  _vm._l(
                                                                    _vm.teamOptions,
                                                                    function(
                                                                      team
                                                                    ) {
                                                                      return _c(
                                                                        "q-item",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "close-overlay",
                                                                              rawName:
                                                                                "v-close-overlay"
                                                                            }
                                                                          ],
                                                                          key:
                                                                            team.value,
                                                                          nativeOn: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeTeams(
                                                                                attendee,
                                                                                team.value
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "q-tooltip",
                                                                            [
                                                                              _vm._v(
                                                                                "Move to:"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                                                            " +
                                                                              _vm._s(
                                                                                team.label
                                                                              ) +
                                                                              "\n                                                        "
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c("q-item-separator", {
                                              staticStyle: { display: "block" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _c("q-inner-loading", { attrs: { visible: _vm.loading } })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }